import { produce } from "immer";
import { initialMachineStateAmpelSystem, initialMachineStateCodeschloss, initialMachineStateDoorSystem, initialMachineStateGaragentor, initialMachineStateKunstautomat1, initialMachineStateKunstautomat2 } from "../state/machineState";
import { MealyModelType } from "../mealyModels/mealyModelType";
// Actions - state
export function node_delete(machineState, nodeId) {
    return produce(machineState, draftState => {
        const draftMachine = draftState.machine;
        delete draftMachine.nodes[nodeId];
        for (let transitionId of Object.keys(draftMachine.transitions)) {
            const transition = draftMachine.transitions[transitionId];
            if (transition.fromNodeId === nodeId || transition.toNodeId === nodeId) {
                delete draftMachine.transitions[transitionId];
            }
        }
        draftState.uiState.selection = {};
    });
}
export function moveMachineState(machineState, nodeId, position) {
    return produce(machineState, draftState => {
        const draftMachine = draftState.machine;
        draftMachine.nodes[nodeId].posx = position.x;
        draftMachine.nodes[nodeId].posy = position.y;
    });
}
export function node_setIsStart(machineState, nodeId) {
    return produce(machineState, draftState => {
        const draftMachine = draftState.machine;
        for (let nodeDraft of Object.values(draftMachine.nodes)) {
            nodeDraft.isStart = false;
        }
        draftMachine.nodes[nodeId].isStart = true;
    });
}
export function node_decreaseHeight(machineState, nodeId) {
    return produce(machineState, draftState => {
        const draftMachine = draftState.machine;
        const node = draftMachine.nodes[nodeId];
        if (node.type === 'NodeRect') {
            const newHeightCandidate = node.height - 10;
            if (newHeightCandidate >= 30) {
                node.height = newHeightCandidate;
            }
        }
    });
}
export function node_decreaseWidth(machineState, nodeId) {
    return produce(machineState, draftState => {
        const draftMachine = draftState.machine;
        const node = draftMachine.nodes[nodeId];
        if (node.type === 'NodeRect') {
            const newWidthCandidate = node.width - 10;
            if (newWidthCandidate >= 30) {
                node.width = newWidthCandidate;
            }
        }
    });
}
export function node_increaseHeight(machineState, nodeId) {
    return produce(machineState, draftState => {
        const draftMachine = draftState.machine;
        const node = draftMachine.nodes[nodeId];
        if (node.type === 'NodeRect') {
            const newHeightCandidate = node.height + 10;
            if (newHeightCandidate <= 120) {
                node.height = newHeightCandidate;
            }
        }
    });
}
export function node_increaseWidth(machineState, nodeId) {
    return produce(machineState, draftState => {
        const draftMachine = draftState.machine;
        const node = draftMachine.nodes[nodeId];
        if (node.type === 'NodeRect') {
            const newWidthCandidate = node.width + 10;
            if (newWidthCandidate <= 120) {
                node.width = newWidthCandidate;
            }
        }
    });
}
export function node_rename(machineState, stateId, name) {
    return produce(machineState, draftState => {
        const draftMachine = draftState.machine;
        draftMachine.nodes[stateId].name = name;
    });
}
export function addState(state, position) {
    return produce(state, draftState => {
        const draftMachine = draftState.machineState.machine;
        const id = draftMachine.nextStateId.toString();
        draftMachine.machineStates[id] = {
            id: id,
            name: id,
            posx: position.x,
            posy: position.y,
            isStart: false,
            isFinal: false,
        };
        draftMachine.nextStateId++;
    });
}
export function machineState_setName(state, machineStateId, name) {
    return produce(state, draftState => {
        const draftMachine = draftState.machineState.machine;
        draftMachine.machineStates[machineStateId].name = name;
    });
}
export function machineState_toggleIsFinal(state, machineStateId) {
    return produce(state, draftState => {
        const draftMachine = draftState.machineState.machine;
        draftMachine.machineStates[machineStateId].isFinal = !draftMachine.machineStates[machineStateId].isFinal;
    });
}
export const machineState_newMachine = (machineType) => (state) => {
    const machineState = (() => {
        switch (machineType) {
            case MealyModelType.DOORSYSTEM:
                return initialMachineStateDoorSystem;
            case MealyModelType.AMPELSYSTEM:
                return initialMachineStateAmpelSystem;
            case MealyModelType.KUNSTAUTOMAT1:
                return initialMachineStateKunstautomat1;
            case MealyModelType.KUNSTAUTOMAT2:
                return initialMachineStateKunstautomat2;
            case MealyModelType.GARAGENTOR:
                return initialMachineStateGaragentor;
            case MealyModelType.CODESCHLOSS:
                return initialMachineStateCodeschloss;
        }
    })();
    return produce(state, draftState => {
        draftState.machineState = machineState;
    });
    // return initialState;
    // return produce(state, draftState => {
    //     draftState.machineState.machine = {
    //         machineStates: {},
    //         transitions: {},
    //         nextStateId: 0,
    //         nextTransitionId: 0,
    //     }
    // });
};
